// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../data/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.field[data-v-0dca8b1a] {\n\tmax-width: 550px;\n}\n", ""]);
// Exports
module.exports = exports;
